import { render, staticRenderFns } from "./protocole-soins.html?vue&type=template&id=7ec08ab2&scoped=true&external"
import script from "./protocole-soins.js?vue&type=script&lang=js&external"
export * from "./protocole-soins.js?vue&type=script&lang=js&external"
import style0 from "./protocole-soins.scss?vue&type=style&index=0&id=7ec08ab2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec08ab2",
  null
  
)

export default component.exports